import React, { Component } from 'react';
import { observable, action, runInAction } from 'mobx';
import { observer } from 'mobx-react';
import { Link } from '@reach/router';
import { keys } from 'lodash';

import { makeRequest, errorResponse } from 'js/services/Network';
import { lightGrey3Color } from 'js/config/style';
import { phoneFormatter } from 'js/services/Format';

import { displaySize } from '../config';
import LoadingSpinner from '../../LoadingSpinner';
import UserLogoIcon from 'js/components/core/Icons/UserLogoIcon';
import Container from './Container';
import Title from './Title';
import Content from './Content';
import Display from './Display';
import Label from './Label';

@observer
export default class User extends Component {
  constructor(props) {
    super(props);
    this.load(props.load);
  }

  @observable error = null;
  @observable isLoading = true;
  @observable.ref data = null;

  hasLoadProps = () =>
    keys(this.props.load || {}).reduce((hasLoadProps, prop) => hasLoadProps && !!this.props.load[prop], true);

  @action async load(props) {
    if (this.hasLoadProps()) {
      this.isLoading = true;
      this.error = null;

      try {
        this.data = (await makeRequest('admin-user-data', null, props)).data;
      } catch (error) {
        runInAction(() => (this.error = errorResponse(error)));
      }

      runInAction(() => (this.isLoading = false));
    } else {
      this.error = 'User not found';
      this.isLoading = false;
    }
  }

  render() {
    return (
      <Container mode={this.isLoading ? 'loading' : 'display'}>
        {this.isLoading ? (
          <LoadingSpinner padding="1rem" />
        ) : this.error ? (
          <>
            <Display>
              <UserLogoIcon color={lightGrey3Color} width={displaySize} />
            </Display>
            <Title>{this.props.title || 'User'}</Title>
            <Content>{this.error}</Content>
          </>
        ) : (
          <>
            <Display>
              <UserLogoIcon color={lightGrey3Color} width={displaySize} />
            </Display>
            <Title>
              <Link to={`/admin/users/user/${this.data.email}`}>{this.props.title || 'User'}</Link>
            </Title>
            <Content>
              <Label>Name</Label>
              <div>
                <Link to={`/admin/users/user/${this.data.email}`}>
                  {this.data.name || 'Unknown name'} (@{this.data.login})
                </Link>
              </div>

              <Label>Email</Label>
              <div>
                <a target="_blank" href={`mailto:${this.data.email}`}>
                  {this.data.email}
                </a>
              </div>

              <Label>Address</Label>
              <div>{this.data.address}</div>

              <Label>Phone</Label>
              <div>
                <a href={`tel:${this.data.phone_number}`}>{phoneFormatter(this.data.phone_number)}</a>
              </div>
            </Content>
          </>
        )}
      </Container>
    );
  }
}
